import { createContext } from "react";
import {
  Lead,
  Membership,
  Institution,
  InsightsUser,
  MembershipInterface,
  Product,
  UserInstitution
} from "../features/common/interfaces/Interface";

export interface OutcomesTerminology {
  outcomes: { singular: string; plural: string };
  learningOutcomes: { singular: string; plural: string };
  successOutcomes: { singular: string; plural: string };
}

const componentLoaded = {
  institution: false,
  membership: false,
  openPreviewModal: false
};

export interface componentLoadedInterface {
  institution: Boolean;
  membership: Boolean;
  openPreviewModal: Boolean;
}

export interface CesUserRole {
  isInstructor: boolean;
  cesUserId: string | number;
}

export interface AppContextInterface {
  institution: Institution | null;
  selectedTab: string;
  onWmTabSelectedEvent: (event: any) => void;
  sysUser: InsightsUser | null;
  componentLoaded: componentLoadedInterface;
  leads: Lead[];
  setleads: (result: Lead) => void;
  setComponentLoaded: (component: string) => void;
  membership: MembershipInterface | null;
  setMembership: (result: Membership) => void;
  closePreviewModal: () => void;
  integratedProducts: Product[] | [];
  institutionsList: UserInstitution[] | [];
  selectedInstitution: string | null;
  setSelectedInstitution: (institution: UserInstitution) => void;
  breadcrumb: string | null;
  setBreadcrumb: (breadcrumb: string) => void;
  cesUserRole: CesUserRole | null;
  outcomesTerminology: OutcomesTerminology | null;
  setOutcomesTerminology: (result: OutcomesTerminology) => void;
  successMetricMessage: string | null;
  openWithSuccessMetricMessage: (message: string) => void;
  clearSuccessMetricMessage: () => void;
  isChatStreaming: boolean;
  setChatStreaming: (val: boolean) => void;
  isAiChatToggleVisible: boolean;
  setAiChatToggleVisible: (val: boolean) => void;
  isAiAssistantAvailable: boolean;
}

export const AppContext = createContext({
  institution: null,
  selectedTab: "",
  onWmTabSelectedEvent: (event: any) => { },
  sysUser: null,
  componentLoaded: componentLoaded,
  leads: [],
  setleads: (result: Lead) => { },
  setComponentLoaded: (component: string) => { },
  membership: null,
  setMembership: (result: Membership) => { },
  closePreviewModal: () => { },
  integratedProducts: null,
  cesUserRole: null,
  outcomesTerminology: null,
  setOutcomesTerminology: (result: OutcomesTerminology) => { },
  successMetricMessage: null,
  openWithSuccessMetricMessage: (message: string) => { },
  clearSuccessMetricMessage: () => { },
  isChatStreaming: false,
  setChatStreaming: (val: boolean) => { },
  isAiChatToggleVisible: false,
  setAiChatToggleVisible: (val: boolean) => { },
  isAiAssistantAvailable: false,
});
